/* =============================================================
   SW BUNDLE  ·  Everyday Chemist
   Behaviour for sections/sw-bundle-builder.liquid.

   State is an ordered list of chosen units (one per slot). The
   CTA posts them to /cart/add.js grouped by variant, each carrying
   the same `_bundleId` + `_bundleTitle: "Custom Set"` properties the
   Build Your Own Bundle page uses, so the store's cart transform
   merges them into one discounted line. Then the native EC drawer
   is refreshed and opened, exactly as build-your-own-bundle.js does.
   ============================================================= */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function num(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var m = fmt.match(ph);
    var token = m ? m[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      case 'amount_with_space_separator': value = num(2, ' ', ','); break;
      default: value = num(2, ',', '.');
    }
    // Match the Liquid `money_without_trailing_zeros` filter used in the markup.
    value = value.replace(/[.,]00$/, '');
    return fmt.replace(ph, value);
  }

  function initBundle(root) {
    if (!root || root.__swBundle) return;
    root.__swBundle = true;

    var size = parseInt(root.getAttribute('data-size'), 10) || 3;
    var pct = parseInt(root.getAttribute('data-pct'), 10) || 0;
    var moneyFormat = root.getAttribute('data-money-format');
    var L = function (k) { return root.getAttribute('data-label-' + k) || ''; };
    var money = function (c) { return formatMoney(c, moneyFormat); };

    var slots = root.querySelectorAll('[data-sw-bundle-slots] [data-slot]');
    var rows = root.querySelectorAll('[data-product]');
    var countEls = root.querySelectorAll('[data-sw-bundle-count]');
    var totalEl = root.querySelector('[data-total]');
    var subEl = root.querySelector('[data-subtotal]');
    var discEl = root.querySelector('[data-discount]');
    var cta = root.querySelector('[data-cta]');
    var errEl = root.querySelector('[data-error]');

    var variants = {};     // id -> {id,title,price,available,image,product}
    var chosen = [];       // [{variantId}]
    var busy = false;

    // Card grid: options open in a panel over the card image.
    var openPicker = null;
    function closePicker(focus) {
      if (!openPicker) return;
      var card = openPicker.closest('[data-product]');
      var toggle = card && card.querySelector('[data-open]');
      openPicker.hidden = true;
      if (card) card.classList.remove('is-picking');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (focus) toggle.focus();
      }
      openPicker = null;
    }

    rows.forEach(function (row) {
      var data = [];
      try { data = JSON.parse(row.querySelector('[data-variants]').textContent); } catch (e) {}
      var title = row.getAttribute('data-product-title');
      data.forEach(function (v) { v.product = title; variants[v.id] = v; });

      row.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-chip]');
        if (chip && !chip.disabled) {
          var id = chip.getAttribute('data-chip');
          row.querySelectorAll('[data-chip]').forEach(function (c) {
            c.setAttribute('aria-checked', c === chip ? 'true' : 'false');
          });
          var add = row.querySelector('[data-add]');
          add.setAttribute('data-variant', id);
          var v = variants[id];
          var priceEl = row.querySelector('[data-price]');
          if (v && priceEl) priceEl.textContent = money(v.price);
          render();
          return;
        }

        var toggle = e.target.closest('[data-open]');
        if (toggle && !toggle.disabled) {
          var picker = row.querySelector('[data-picker]');
          if (openPicker === picker) { closePicker(false); return; }
          closePicker(false);
          picker.hidden = false;
          row.classList.add('is-picking');
          toggle.setAttribute('aria-expanded', 'true');
          openPicker = picker;
          var first = picker.querySelector('[data-chip][aria-checked="true"]') || picker.querySelector('[data-add]');
          if (first) first.focus({ preventScroll: true });
          return;
        }

        if (e.target.closest('[data-picker-close]')) { closePicker(true); return; }

        var addBtn = e.target.closest('[data-add]');
        if (addBtn && !addBtn.disabled) {
          if (chosen.length >= size) return;
          chosen.push({ variantId: addBtn.getAttribute('data-variant') });
          if (openPicker && row.contains(openPicker)) closePicker(false);
          render();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (openPicker && !openPicker.closest('[data-product]').contains(e.target)) closePicker(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openPicker) closePicker(true);
    });

    slots.forEach(function (slot) {
      var rm = slot.querySelector('[data-remove]');
      rm.addEventListener('click', function () {
        var i = parseInt(slot.getAttribute('data-slot'), 10);
        chosen.splice(i, 1);
        render();
      });
    });

    function render() {
      var full = chosen.length >= size;
      var gross = 0, save = 0;

      chosen.forEach(function (c) {
        var v = variants[c.variantId];
        if (!v) return;
        gross += v.price;
        save += Math.round(v.price * pct / 100);
      });
      if (!full) save = 0;

      slots.forEach(function (slot, i) {
        var c = chosen[i];
        var v = c && variants[c.variantId];
        var plinth = slot.querySelector('[data-plinth]');
        var name = slot.querySelector('[data-name]');
        var meta = slot.querySelector('[data-meta]');
        var rm = slot.querySelector('[data-remove]');
        slot.classList.toggle('is-filled', !!v);
        if (v) {
          plinth.innerHTML = v.image
            ? '<img src="' + v.image + '" alt="' + escapeHtml(v.product) + '" loading="lazy">'
            : '';
          name.textContent = v.product;
          meta.textContent = (v.title && v.title !== 'Default Title' ? v.title + ' · ' : '') + money(v.price);
          rm.hidden = false;
        } else {
          plinth.innerHTML = '<span class="sw-bundle__empty-mark">Empty</span>';
          name.textContent = L('empty-name');
          meta.textContent = L('empty-meta');
          rm.hidden = true;
        }
      });

      var left = size - chosen.length;
      var countText = chosen.length + '/' + size + ' selected · ' + (full ? L('done') : left + ' ' + L('togo'));
      countEls.forEach(function (el) { el.textContent = countText; });
      subEl.textContent = money(gross);
      discEl.textContent = save > 0 ? '− ' + money(save) : money(0);
      totalEl.textContent = money(gross - save);

      rows.forEach(function (row) {
        var add = row.querySelector('[data-add]');
        var v = variants[add.getAttribute('data-variant')];
        var soldOut = v && !v.available;
        add.disabled = full || soldOut || busy;
        add.classList.toggle('is-full', full && !soldOut);
        var base = add.getAttribute('data-label') || L('add');
        if (!soldOut) {
          add.textContent = full ? L('full')
            : base + (add.hasAttribute('data-with-price') && v ? ' · ' + money(v.price) : '');
        }
      });

      root.querySelectorAll('[data-open]').forEach(function (toggle) {
        toggle.disabled = full || busy;
        toggle.textContent = full ? L('full') : toggle.getAttribute('data-label');
      });
      if (full) closePicker(false);

      if (busy) return;
      cta.disabled = !full;
      cta.classList.toggle('is-ready', full);
      cta.textContent = full
        ? L('cta') + ' — ' + money(gross - save)
        : L('more').replace('[n]', left);
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    cta.addEventListener('click', function () {
      if (cta.disabled || chosen.length < size) return;
      busy = true;
      errEl.hidden = true;
      cta.disabled = true;
      cta.textContent = 'Adding…';

      var bundleId = 'byob-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e6).toString(36);
      var qty = {};
      var order = [];
      chosen.forEach(function (c) {
        if (!qty[c.variantId]) { qty[c.variantId] = 0; order.push(c.variantId); }
        qty[c.variantId] += 1;
      });
      var items = order.map(function (id) {
        return { id: parseInt(id, 10), quantity: qty[id], properties: { _bundleId: bundleId, _bundleTitle: 'Custom Set' } };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body && (body.description || body.message) || 'Could not add the bundle');
            return body;
          });
        })
        .then(function () {
          var openDrawer = function () {
            document.dispatchEvent(new CustomEvent('add-to-cart'));
            if (typeof window.ecOpenCartDrawer === 'function') window.ecOpenCartDrawer();
            else window.location.href = '/cart';
          };
          if (typeof window.refreshCart === 'function') {
            Promise.resolve(window.refreshCart()).then(openDrawer, openDrawer);
          } else {
            openDrawer();
          }
          chosen = [];
          busy = false;
          render();
        })
        .catch(function (err) {
          busy = false;
          errEl.textContent = err && err.message ? err.message : 'Something went wrong. Try again.';
          errEl.hidden = false;
          render();
        });
    });

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-sw-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
